import { Text } from '@shared/components';
import { Dropdown } from '@shared/components/plugin-components';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { useAuthContext } from '@shared/contexts/useAuthContext';
import { useCreateEmptyQuote } from '@shared/hooks/useCreateEmptyQuote';
import { useLogout } from '@shared/hooks/useLogout';
import { hasChatsAccess } from '@shared/utils/permissions';
import {
  ACTIVITY_ROUTE,
  CHATS_ROUTE,
  QUOTES_ROUTE,
} from 'clerk_common/constants/urls/routes';
import { useLocation, useNavigate } from 'react-router-dom';

type MenuProps = {
  hasChats?: boolean;
};

const Menu = ({ hasChats = false }: MenuProps) => {
  const { logout: logoutFromAuth0 } = useAuthContext();
  const { logout: logoutFromApi } = useLogout();
  const { hasQuotes, hasVee, isVoomaAdmin } = useMeContext();
  const { createEmptyQuote } = useCreateEmptyQuote();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onLogout = () => {
    logoutFromAuth0();
    logoutFromApi();
  };

  const getItems = () => {
    return [
      ...(pathname !== ACTIVITY_ROUTE
        ? [
            {
              node: (
                <button
                  className="w-full py-2 text-left"
                  onClick={() => {
                    navigate(ACTIVITY_ROUTE);
                  }}
                  type="button"
                >
                  <Text type="body-xs">Activity</Text>
                </button>
              ),
            },
          ]
        : []),
      ...(hasChats && hasChatsAccess({ hasVee, isVoomaAdmin })
        ? [
            {
              node: (
                <button
                  className="w-full py-2 text-left"
                  onClick={() => {
                    navigate(CHATS_ROUTE);
                  }}
                  type="button"
                >
                  <Text type="body-xs">Chats</Text>
                </button>
              ),
            },
          ]
        : []),
      ...(hasQuotes
        ? [
            {
              node: (
                <div
                  className="py-2"
                  onClick={() => {
                    navigate(QUOTES_ROUTE);
                  }}
                >
                  <Text type="body-xs">Quotes</Text>
                </div>
              ),
            },
            {
              node: (
                <div
                  className="py-2"
                  onClick={async () => {
                    const res = await createEmptyQuote();
                    if (res) {
                      navigate(`${QUOTES_ROUTE}/${res.id}`);
                    }
                  }}
                >
                  <Text type="body-xs">Instant Quote</Text>
                </div>
              ),
            },
          ]
        : []),
      {
        node: (
          <div
            className="py-2"
            onClick={() => {
              navigate('/settings');
            }}
          >
            <Text type="body-xs">Account settings</Text>
          </div>
        ),
      },
      {
        node: (
          <div onClick={onLogout} className="py-2">
            <Text type="body-xs">Log out</Text>
          </div>
        ),
      },
    ];
  };

  return <Dropdown items={getItems()} />;
};
export default Menu;
